import React from 'react';
import { Link } from 'react-router-dom';

function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-main">
          <div className="footer-brand">
            <Link to="/" className="footer-logo">
              <span className="logo-text">Samantha</span>
              <span className="logo-accent">de Nicola</span>
            </Link>
            <p className="footer-tagline">
              Crafting immersive worlds and unforgettable moments
            </p>
          </div>

          <div className="footer-links-grid">
            <div className="footer-links-column">
              <h4>Explore</h4>
              <ul>
                <li><Link to="/experiential/immersive">Immersive Experiences</Link></li>
                <li><Link to="/experiential/digital">Digital & Interactive</Link></li>
                <li><Link to="/experiential/concepts">Concepts</Link></li>
                <li><Link to="/about">About</Link></li>
              </ul>
            </div>

            <div className="footer-links-column">
              <h4>Connect</h4>
              <ul>
                <li>
                  <a href="mailto:sami@samidenicola.com">Email</a>
                </li>
                {/* LinkedIn hidden for now
                <li>
                  <a
                    href="https://linkedin.com/in/samidenicola"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    LinkedIn
                  </a>
                </li>
                */}
              </ul>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p className="footer-copyright">
            &copy; {currentYear} Samantha de Nicola. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
